export default __webpack_public_path__ + "static/media/musor.b120c4f9.svg";